export const redirect = (url: string): void => {
  location.href = url;
};
